<template>
	<Teleport to="body">
		<Accessible
			:name="accessibleName"
			trapped
			focusFirstItem
			autoFocus
			trapOn="Tab"
			:wait="250"
			:tabOrder="[{ css: '.modal-close-btn', clickOnEnter: true }, ...tabOrder]"
		>
			<Modal
				:fullscreen="fullscreen"
				:onBeforeClose="onBeforeClose"
				:noEsc="noEsc"
				@close="$emit('close', $event)"
				ref="modal"
				v-bind="$attrs"
			>
				<template v-slot>
					<CloseIcon
						hover
						v-if="!hideClose"
						@click="$refs.modal.close()"
						class="modal-close-btn"
						:aria-label="$t('common_button_close')"
						tabindex="0"
						data-cy="modal-close"
						role="button"
					/>
					<slot />
					<SpinnerOverlay v-if="loadingOverlay" class="loading-overlay" />
				</template>
			</Modal>
		</Accessible>
	</Teleport>
</template>

<script>
import { CloseIcon } from '@/icons'
import Modal from './Modal'
import Accessible from './Accessible'
import SpinnerOverlay from '../SpinnerOverlay'

export default {
	name: 'SimpleModal',
	components: { Modal, CloseIcon, Accessible, SpinnerOverlay },
	props: {
		onBeforeClose: {
			type: Function,
		},
		fullscreen: {
			type: Boolean,
			default: null,
		},
		hideClose: {
			type: Boolean,
			default: null,
		},
		noEsc: {
			type: Boolean,
			default: null,
		},
		tabOrder: {
			type: Array,
			default: () => [],
		},
		accessibleName: {
			type: String,
			default: 'simplemodal',
		},
		loadingOverlay: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['close'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.modal-close-btn {
	cursor: pointer;
	position: absolute;
	top: 20px;
	right: 20px;
	z-index: 1;
	outline: 0;
	font-size: 24px;
	color: gray;
}
.loading-overlay {
	@include flex-center;
	@include absolute-cover(1000);
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.modal-content {
		.loading-overlay {
			background: var(--neutral-200) !important;
			.ios-spinner {
				background: var(--neutral-200) !important;
			}
		}
	}
}
</style>
